import { useEffect, useState } from "react";
/**
 * Custom hook to manage the source of an image, with optional Base64 conversion.
 *
 * @param src - The source URL of the image.
 * @param useBase64 - A boolean indicating whether to convert the image to Base64 format. Defaults to `false`.
 * @returns The image source as a string, either the original URL or a Base64-encoded string.
 */
const useImageSrc = (src: string, useBase64?: boolean) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);

  useEffect(() => {
    if (useBase64) {
      fetch(src)
        .then(response => response.blob()) // Convert to Blob
        .then(blob => {
          const reader = new FileReader();
          reader.onloadend = () => setImageSrc(reader.result as string);
          reader.readAsDataURL(blob); // Convert to Base64
        })
        .catch(error => console.error("Error loading image", error));
    } else {
      setImageSrc(src);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- deps kept as they were; changing them changes when this runs
  }, [useBase64]);
  return imageSrc;
};
export default useImageSrc;
